<template>
  <SectionBox fullHeight shadow="none">
    <BasicSection>
      <SavedFiltersList
        v-if="savedFilters.items.length !== 0"
        :savedFilters="savedFilters.items"
        @click="$emit('loadSavedFilter', $event)"
        @remove="savedFilters.remove"
      />
      <NoContent
        v-else
        title="Сохраненных фильтров нет"
        :description="description"
        :actions="actions"
      />
    </BasicSection>
  </SectionBox>
</template>

<script>
  import SavedFiltersList from "src/components/filters/SavedFiltersList/SavedFiltersList.vue";
  import NoContent from "src/components/placeholders/NoContent/NoContent.vue";
  import SectionBox from "src/components/SectionBox/SectionBox.vue";
  import BasicSection from "src/components/sections/BasicSection/BasicSection.vue";

  export default {
    name: 'SavedFiltersScreen',
    components: { SectionBox, BasicSection, SavedFiltersList, NoContent },
    props: {
      description: String,
    },
    inject: ['savedFilters'],
    computed: {
      actions() {
        return [
          {
            title: 'Начать поиск',
            appearance: 'primary',
            listeners: {
              click: () => {
                this.$emit('primaryActionClick');
              }
            },
          },
        ];
      }
    }
  }
</script>